const games = {
    other: [
        {
            api: '',
            display_types: [16],
            id: 1940,
            image: '/assets/img/games-page/xeng-hoa-qua.png',
            image_app: '',
            image_feature: '',
            name: 'Xèng Hoa Quả',
            partner_game_id: 'qs_xengfruit',
            partner_provider: '',
            shouldFetchLink: false,
            type: 1,
            path: 'https://xeng.quayso.club/?token='
        }
    ]
};

export default games;
